import {TooltipModule} from 'ng-design-system';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PlansAndPricingComponent} from './plans-and-pricing.component';
import {ConfigModule, I18nModule, TranslatePipe} from '@spartacus/core';
import {PlansAndPricingDataService} from './plans-and-pricing-data.service';
import {PlansAndPricingFeaturesComponent} from './plans-and-pricing-features/plans-and-pricing-features.component';
import {PlansAndPricingDisplayComponent} from './plans-and-pricing-display/plans-and-pricing-display.component';
import {
  PlansAndPricingCommonFeaturesComponent
} from './plans-and-pricing-common-features/plans-and-pricing-common-features.component';
import {
  PlansAndPricingBundleOptionComponent
} from './plans-and-pricing-bundle-option/plans-and-pricing-bundle-option.component';
import {CheckmarkListModule} from '../../../shared/checkmark-list/checkmark-list.module';
import {CtaFormModule} from '../../cta-form/cta-form.module';
import {PlansAndPricingTooltipComponent} from './plans-and-pricing-tooltip/plans-and-pricing-tooltip.component';
import {PriceFormatModule} from './price-format-pipe/price-format.module';
import {TermsAndConditionsModule} from '../../../checkout/checkout-terms-conditions/terms-and-conditions.module';

@NgModule({
  declarations: [
    PlansAndPricingComponent,
    PlansAndPricingFeaturesComponent,
    PlansAndPricingDisplayComponent,
    PlansAndPricingCommonFeaturesComponent,
    PlansAndPricingBundleOptionComponent,
    PlansAndPricingTooltipComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductPlansAndPricingComponent: {
          component: PlansAndPricingComponent
        }
      }
    }),
    I18nModule,
    CheckmarkListModule,
    CtaFormModule,
    TooltipModule,
    PriceFormatModule,
    TermsAndConditionsModule,
  ],
  providers: [
    PlansAndPricingDataService,
    TranslatePipe,
  ],
  exports: [
    PlansAndPricingComponent,
    PlansAndPricingFeaturesComponent,
    PlansAndPricingDisplayComponent,
    PlansAndPricingCommonFeaturesComponent,
    PlansAndPricingTooltipComponent,
  ]
})
export class PlansAndPricingModule {
}
